import { SelectedItemTheme } from "@components/atoms/Button/types";
import { ProductCategory } from "@utils/constants";
import { productNameToTokenCategory } from "@utils/index";

export enum SearchFilterEnum {
  enhancements = "enhancements",
  single_stones = "Single Stones",
}

export const treatmentValues = [
  "HPHT",
  "Clarity Enhancement",
  "Drill",
  "None,Non-treated,As Grown",
  "HPHT,LPHT,Irradiation",
  "Others,Unknown,Null,Blank",
];

export enum SearchFilterTypeEnum {
  SINGLE_STONES = "Single Stones",
  PAIRS = "Pairs",
  JEWELRY = "Jewelry",
  LAB_GROWN_JEWELRY = "Lab-Grown Jewelry",
  PARCEL = "Parcel",
}

export enum SearchFilterTypeEnumLowercase {
  SINGLE_STONES = "single_stones",
  PAIRS = "pair",
  PARCEL = "parcel",
  LOOSE_PARCEL = "loose_parcel",
}

export enum SearchFilterNameEnum {
  TOTAL_PRICE = "Total Price",
  PRICE_PER_CARAT = "P/ct",
  Fancy = "Fancy",
  White = "White",
}

const getStyleForSearchCategory = (
  type: string,
  custom_theme: boolean
): SelectedItemTheme => {
  const tokenCat = productNameToTokenCategory(type as ProductCategory);
  if (custom_theme) {
    return {
      primary: "option-bg-active",
      secondary: `${tokenCat}-06`,
      one: `${tokenCat}-01`,
      three: `${tokenCat}-03`,
    };
  } else {
    return {
      primary: `${tokenCat}-03`,
      secondary: `${tokenCat}-06`,
      one: `${tokenCat}-01`,
      three: `${tokenCat}-03`,
    };
  }
};

export { getStyleForSearchCategory };
